export enum IntegratedEmailsPermissions {
  SEND_EMAIL = 'integratedEmails.sendEmail',
}
